import api from './api';
import type { InventoryItemType } from '../types/venue';

// ── Types ─────────────────────────────────────────────────────────────────────

export type AlertType =
  | 'NEGATIVE_STOCK'
  | 'OUT_OF_STOCK'
  | 'LOW_STOCK'
  | 'NO_SUPPLIER_LINK'
  | 'NEVER_RECEIVED';

export interface InventoryAlert {
  type: AlertType;
  inventoryItemId: string;
  displayName: string | null;
  locationName: string | null;
  quantity: number;
  itemType?: InventoryItemType;
  bottleSize?: number;
  reorderPoint?: number;
  reorderSuggestion?: number;
}

export interface AlertSummary {
  negativeStock: number;
  outOfStock: number;
  lowStock: number;
  missingSupplier: number;
  neverReceived: number;
}

export interface AlertsResponse {
  summary: AlertSummary;
  alerts: InventoryAlert[];
}

// ── Service ───────────────────────────────────────────────────────────────────

const base = (venueId: string) => `/admin/venue/${venueId}/inventory/alerts`;

const inventoryAlertService = {
  getAlerts: async (
    venueId: string,
    categoryId?: string | 'none',
    type?: InventoryItemType,
  ): Promise<AlertsResponse> => {
    const params: Record<string, unknown> = {};
    if (categoryId) params.categoryId = categoryId;
    if (type) params.type = type;
    const response = await api.get<AlertsResponse>(base(venueId), { params });
    return response.data;
  },
};

export default inventoryAlertService;
